module.exports = __webpack_public_path__ + "img/concrete-hole-decal-27.6a4d9a57.png";